export default "__VITE_ASSET__CArLZREr__"